function topic_fire_report(){
	$("#legend_div_container").append(`
		<div class="legend_text">
			火災通報熱區<br>
			<img class="w-100" src="legend/hotspot.png">
		</div>
		<div class="legend_text">
			火災通報點位<br>
			<img src="marker_icon/fire_point.png" width="32">
		</div>
	`)
	var	nowDateObject = get_now_time_object(),
		regionOption = "", 
		end_day_utc = get_now_time_utc_value() - (8 * 3600000),
		start_day_utc = end_day_utc - (30 * 24 * 3600000),
		start_day = UTCtoString_v2(start_day_utc),
		end_day = UTCtoString_v2(end_day_utc)
	Object.keys(regionTID).forEach(function(eachRegion){
		regionOption += `<option value="${eachRegion}">${eachRegion}</option>`
	})
	$("#home4 .card-body").html(
		slider_card_component_create({
			"cardhead": "監控資料追蹤",
			"cardbody": data_source_table_html("火災決策")
		}, false) +
		`<ul id="topic-fire-report-ul" class="nav nav-tabs mt-5p" role="tablist">
			<li class="nav-item w-33 text-center">
				<a class="nav-link active" data-toggle="tab" href="#topic-fire-report-hazard" role="tab">火災風險因子分布</a>
			</li>
			<li class="nav-item w-33 text-center">
				<a class="nav-link" data-toggle="tab" href="#topic-fire-report-risk" role="tab">火災風險熱區推估</a>
			</li>
			<li class="nav-item w-33 text-center">
				<a class="nav-link" data-toggle="tab" href="#topic-fire-report-history" role="tab">歷史火災點位查詢</a>
			</li>
		</ul>
		<div class="tab-content mostly-customized-scrollbar pr-2" id="topic_fire_report_main_div">
			<div class="tab-pane fade show active mb-5" role="tabpanel" id="topic-fire-report-hazard"></div>
			<div class="tab-pane fade" role="tabpanel" id="topic-fire-report-risk">
				<h5 class="font-weight-bold mb-1 mt-2"><i class="fas fa-sliders-h mr-2"></i>火災風險熱區檢視設定</h5>
				<h6 class="text-justify">基於119災情資料庫火災通報，依據季節與時段繪製風險熱區地圖、行政區好發風險長條圖與火警類型圓餅圖，以提供使用者在不同時間下針對火災熱區風險的參考與應用。另系統會依照使用者時間，先行預設符合的季節與時段。</h6>
				<div class="input-group">
					<div class="input-group-prepend">
						<span class="input-group-text">季節選擇</span>
					</div>
					<select class="custom-select" id="topic-fire-report-risk-input-season">
						<option value="春季">春季 (3~5月)</option>
						<option value="夏季">夏季 (6~8月)</option>
						<option value="秋季">秋季 (9~11月)</option>
						<option value="冬季">冬季 (12~1月)</option>
					</select>
				</div>
				<div class="input-group mb-2 mt-2">
					<div class="input-group-prepend">
						<label class="input-group-text">時段選擇</label>
					</div>
					<select class="custom-select" id="topic-fire-report-risk-input-time">
						<option value="清晨">清晨 (00:00 ~ 06:00)</option>
						<option value="上午">上午 (06:00 ~ 12:00)</option>
						<option value="下午">下午 (12:00 ~ 18:00)</option>
						<option value="夜晚">夜晚 (18:00 ~ 00:00)</option>
					</select>
				</div>
				<button type="button" class="btn btn-success btn-sm btn-block mt-2" id="topic-fire-report-risk-trig">查詢</button>
				<hr>
				<div id="topic-fire-report-risk-content"></div>
			</div>
			<div class="tab-pane fade" role="tabpanel" id="topic-fire-report-history">
				<h5 class="font-weight-bold mb-1 mt-2"><i class="fas fa-sliders-h mr-2"></i>歷史火災案件檢視設定</h5>
				<h6 class="text-justify">基於119災情資料庫火災通報，使用者可依據時間(時段預設為近30天)與區域類別(鄉鎮區)，以調閱出火災通報紀錄詳細資料(包含地址、通報時間、日期與火災類型等)。</h6>
				<div class="input-group">
					<div class="input-group-prepend">
						<span class="input-group-text">時段選擇</span>
					</div>
					<input type="text" class="form-control date-picker" id="topic-fire-report-history-input-year-start" value="${start_day.slice(0, 4)}-${start_day.slice(5, 7)}-${start_day.slice(8, 10)}">
					<input type="text" class="form-control date-picker" id="topic-fire-report-history-input-year-end" value="${end_day.slice(0, 4)}-${end_day.slice(5, 7)}-${end_day.slice(8, 10)}">
				</div>
				<div class="input-group mb-2 mt-2">
					<div class="input-group-prepend">
						<label class="input-group-text">區域選擇</label>
					</div>
					<select class="custom-select" id="topic-fire-report-history-input-region">
						<option value="all" selected>全部</option>
						${regionOption}
					</select>
				</div>
				<button type="button" class="btn btn-success btn-sm btn-block mt-2" id="topic-fire-report-history-trig">查詢</button>
				<hr>
				<div id="topic-fire-report-history-content"></div>
			</div>
		</div>`
	)

	// 火災風險因子分布
	let dangerous_buildings = slider_card_component_create({
		"cardhead": "高危險建築物",
		"cardbody": `<div class="row m-1">
			<div class="col-12 mt-2 mb-3">
				<h5 class="font-weight-bold"><i class="fas fa-map-marker-alt"></i>高風險建築物地圖類型切換</h5>
				<div class="btn-group btn-group-toggle" data-toggle="buttons">
					<button id="dangerous_buildings_points" class="btn btn-secondary btn-sm bg-primary">點位圖</button>
					<button id="dangerous_buildings_heatmap" class="btn btn-secondary btn-sm">熱度圖</button>
				</div>
			</div>
			<div class="col-12">
				<h5 class="font-weight-bold"><i class="fas fa-signal"></i>高風險建築物數量行政區長條圖</h5>
				<div class="btn-group mb-2" role="group">
					<button type="button" class="btn btn-primary btn-sm">
						目前檢視為：<span class="dangerous_buildings_filter_title">全市</span>
					</button>
					<button type="button" class="btn btn-secondary btn-sm" id="dangerous_buildings_refilter_trig">重新篩選</button>
				</div>    
				<div class="function-log w-100 h-300" function-log-id="19" id="dangerous_buildings_bar_chart"></div>
			</div>
			<div class="col-12 d-none">
				<h5 class="font-weight-bold">
					<i class="fas fa-chart-pie"></i>高風險建築物類型圓餅圖（目前檢視為：
					<span class="dangerous_buildings_filter_title text-primary">全市</span>）
				</h5>
				<h5 id="type-disabled-alert" class="d-none bg-primary text-center text-white py-2">
					請先回復<b>高風險建築物位置圓餅圖</b>至初始狀態
				</h5>
				<div class="function-log w-100 h-400" function-log-id="20" id="dangerous_buildings_type_pie_chart"></div>
			</div>
			<div class="col-12 d-none">
				<h5 class="font-weight-bold">
					<i class="fas fa-chart-pie"></i>高風險建築物位置圓餅圖（目前檢視為：
					<span class="dangerous_buildings_filter_title text-primary">全市</span>）
				</h5>
				<h5 id="location-disabled-alert" class="d-none bg-primary text-center text-white py-2">
					請先回復<b>高風險建築物類型圓餅圖</b>至初始狀態
				</h5>
				<div class="function-log w-100 h-400" function-log-id="20" id="dangerous_buildings_location_pie_chart"></div>
			</div>
			<div class="col-12">
				<h5 class="font-weight-bold"><i class="fas fa-table"></i>高風險建築物列表</h5>
				<table id="dangerous_buildings_list" width="100%" height="100%">
					<thead>
						<tr>
							<th style="width:15%">行政區</th>
							<th style="width:25%">地址</th>
							<th style="width:30%">建物名稱</th>
							<th style="width:15%">建物類型</th>
							<th style="width:15%">建物位置</th>
						</tr>
					</thead>
					<tbody style="cursor:pointer"></tbody>
				</table>
				<button function-log-id="21" type="button" class="btn btn-success btn-sm btn-block mt-2 function-log" id="dangerous_buildings_download">表單下載</button>
			</div>
		</div>`
	}, false)
	
	let chemicals = slider_card_component_create({
		"cardhead": "毒化物與其他化學品",
		"cardbody": `<div class="row m-1">
			<div class="col-12 mt-2 mb-3">
				<h5 class="font-weight-bold"><i class="fas fa-map-marker-alt"></i>地圖類型切換</h5>
				<div class="btn-group btn-group-toggle" data-toggle="buttons">
					<button id="chemicals_points" class="btn btn-secondary btn-sm bg-primary">點位圖</button>
					<button id="chemicals_heatmap" class="btn btn-secondary btn-sm">熱度圖</button>
				</div>
			</div>
			<div class="col-12">
				<h5 class="font-weight-bold"><i class="fas fa-signal"></i>儲存場所數量行政區長條圖</h5>
				<div class="btn-group mb-2" role="group">
					<button type="button" class="btn btn-primary btn-sm">
						目前檢視為：<span class="chemicals_filter_title">全市</span>
					</button>
					<button type="button" class="btn btn-secondary btn-sm" id="chemicals_refilter_trig">重新篩選</button>
				</div>    
				<div class="function-log w-100 h-300" function-log-id="19" id="chemicals_bar_chart"></div>
			</div>
			<div class="col-12">
				<h5 class="font-weight-bold"><i class="fas fa-table"></i>儲存場所與儲存物列表</h5>
				<table id="chemicals_list" width="100%" height="100%">
					<thead>
						<tr>
							<th style="width:10%">行政區</th>
							<th style="width:15%">地址</th>
							<th style="width:15%">儲存場所</th>
							<th style="width:30%">毒化物名稱</th>
							<th style="width:30%">其他化學品名稱</th>
						</tr>
					</thead>
					<tbody style="cursor:pointer"></tbody>
				</table>
				<button function-log-id="21" type="button" class="btn btn-success btn-sm btn-block mt-2 function-log" id="chemicals_download">表單下載</button>
			</div>
		</div>`
	}, false)

	$("#topic-fire-report-hazard").html(
		dangerous_buildings + chemicals
	)

	create_dangerous_buildings_chart()
	create_chemicals_chart()

	// 火災熱區&點位共用
	function topic_fire_report_remove(){
		if (overlay_dataset["topic-fire-report-risk-layer"]) { map.removeLayer(overlay_dataset["topic-fire-report-risk-layer"]) }
		if (overlay_dataset["topic-fire-report-history-layer"]) { map.removeLayer(overlay_dataset["topic-fire-report-history-layer"]) }
	}

	// 火災風險熱區推估
	$("#topic-fire-report-risk-trig").click(function(){
		topic_fire_report_remove()
		var input = {
				time: $("#topic-fire-report-risk-input-time").val(),
				season: $("#topic-fire-report-risk-input-season").val()
			},
			btnDOM = $(this)
		btnDOM.attr("disabled", true)
		$("#topic-fire-report-risk-content").html('<div class="spinner-border text-danger" role="status"> <span class="sr-only">Loading...</span> </div>')
		ajax_call_async(publicPath + "/napi/obs/firehotspot?time=" + input.time + "&season=" + input.season, function(res){
			var staObject = fire_risk_heatmap(res, 3)
			$("#topic-fire-report-risk-content").html(`
				<h5 class="font-weight-bold mb-2 mt-2"><i class="far fa-chart-bar mr-2"></i>火災風險熱區情資分析<button type="button" class="btn btn-success btn-sm float-right" id="topic-fire-report-risk-content-refresh">重新篩選</button></h5>
				<p class="text-center text-muted m-0">行政區火災風險高低圖</p>
				<div id="topic-fire-report-risk-region-chart" class="w-100 h-300"></div>
				<p class="text-center text-muted mb-0 mt-3" id="topic-fire-report-risk-type-chart-title">火災通報類型風險比例圖</p>
				<div id="topic-fire-report-risk-type-chart" class="w-100 h-380"></div>`
			)
			var chart = {
					region: {
						name: Object.keys(staObject.region).sort(function(a,b){ return staObject.region[b]-staObject.region[a]}),
						value: []
					}
				}
			chart.region.name.forEach(function(each){
				chart.region.value.push(staObject.region[each])
			})
			Highcharts.chart('topic-fire-report-risk-region-chart', {
				chart: {
					type: 'column'
				},
				title: {
					text: ''
				},
				legend: {
					enabled: false
				},
				xAxis: {
					categories: chart.region.name,
					labels: {
						step: 1,
						style: {
							fontWeight: 'bold',
							color: 'rgba(0, 0, 0, 1)',
							fontSize: '12px'
						},
						useHTML: true,
						formatter: function(){
							return this.value.slice(0, 1) + "<br>" + this.value.slice(1, 2);
						}
					}
				},
				yAxis: {
					title: {
						text: '風險低 - 風險高'
					},
					labels: {
						enabled: false           
					}
				},
				tooltip: {
					enabled: false
				},
				plotOptions: {
					column: {
						stacking: 'normal',
						dataLabels: {
							enabled: false,
							color: (Highcharts.theme && Highcharts.theme.dataLabelsColor) || 'white'
						}
					},
					series: {
						cursor: 'pointer',
						point: {
							events: {
								click: function () {
									var filter_region = this.category,
										newRes = res.filter(function(el){
											return el.region == filter_region
										})
									zoomToRegionMap(filter_region)
									var staObject = fire_risk_heatmap(newRes, 2)
									fire_type_pie_chart(staObject, newRes, filter_region)
								}
							}
						}
					}
				},
				series: [{
					name: '',
					color: 'rgba(232, 90, 113, 1)',
					data: chart.region.value
				}]
			})
			fire_type_pie_chart(staObject, res)
			$("#topic-fire-report-risk-content-refresh").click(function(){
				$("#home_view").click()
				var staObject = fire_risk_heatmap(res, 3)
				fire_type_pie_chart(staObject, res)
			})
			btnDOM.attr("disabled", false)
		})
	})
	$('.date-picker').datepicker({
		format: 'yyyy-mm-dd',
		orientation: 'bottom'
	})
	switch(true){
		case (nowDateObject.month == 3):
		case (nowDateObject.month == 4):
		case (nowDateObject.month == 5):
			$("#topic-fire-report-risk-input-season").val("春季")
			break
		case (nowDateObject.month == 6):
		case (nowDateObject.month == 7):
		case (nowDateObject.month == 8):
			$("#topic-fire-report-risk-input-season").val("夏季")
			break
		case (nowDateObject.month == 9):
		case (nowDateObject.month == 10):
		case (nowDateObject.month == 11):
			$("#topic-fire-report-risk-input-season").val("秋季")
			break
		case (nowDateObject.month == 12):
		case (nowDateObject.month == 1):
		case (nowDateObject.month == 2):
			$("#topic-fire-report-risk-input-season").val("冬季")
			break
	}
	switch(true){
		case (nowDateObject.hour >= 0 && nowDateObject.hour < 6):
			$("#topic-fire-report-risk-input-time").val("清晨")
			break
		case (nowDateObject.hour >= 6 && nowDateObject.hour < 12):
			$("#topic-fire-report-risk-input-time").val("上午")
			break
		case (nowDateObject.hour >= 12 && nowDateObject.hour < 18):
			$("#topic-fire-report-risk-input-time").val("下午")
			break
		case (nowDateObject.hour >= 18 && nowDateObject.hour < 24):
			$("#topic-fire-report-risk-input-time").val("夜晚")
			break
	}
	function fire_risk_heatmap(res, heatWeight){
		if (overlay_dataset["topic-fire-report-risk-layer"]) { map.removeLayer(overlay_dataset["topic-fire-report-risk-layer"]) }
		var pointArray = { max:heatWeight, data:[] }, 
			cfg = {
				"radius": 0.003,
				"maxOpacity": .8,
				"scaleRadius": true,
				"useLocalExtrema": false,
				latField: 'lat',
				lngField: 'lng',
				valueField: 'count'
			},
			staObject = {
				region: {}, type: {}
			}
		res.forEach(function(each){
			try {
				each.type = reportType119[String(each.type)].caseTypeName.replace("火警-", "")
			} catch (e) {
				// each.type = each.type
			}
			if (!staObject.region[each.region]) { staObject.region[each.region] = 0 }
			if (!staObject.type[each.type]) { staObject.type[each.type] = 0 }
			staObject.region[each.region] += 1
			staObject.type[each.type] += 1
			pointArray.data.push({lat: each.lat, lng: each.lon, count: 1})
		})
		overlay_dataset["topic-fire-report-risk-layer"] = new HeatmapOverlay(cfg)
		overlay_dataset["topic-fire-report-risk-layer"].setData(pointArray)
		overlay_dataset["topic-fire-report-risk-layer"].addTo(map)
		return staObject
	}
	function fire_type_pie_chart (staObject, res, region) {
		var data_input = {
				name: Object.keys(staObject.type).sort(function(a,b){ return staObject.type[b]-staObject.type[a]}),
				value: []
			}
		data_input.name.forEach(function(each){
			data_input.value.push(staObject.type[each])
		})
        var pieColors = get_red_color_schema(data_input.name), chart_array_disatype = []
		data_input.name.forEach(function(el, index){
			chart_array_disatype.push({
				name: el,
				y: data_input.value[index]
			})
		})
        Highcharts.chart('topic-fire-report-risk-type-chart', {
            chart: {
                type: 'pie'
            },
            title: {
                text: ''
            },
            tooltip: {
                useHTML: true,
                headerFormat: '<span class="h5">{point.key}案件</span><br>',
                pointFormat: '{series.name} <b>{point.percentage:.1f}%</b>'
            },
            plotOptions: {
                pie: {
                    cursor: 'pointer',
                    colors: pieColors,
                    borderWidth: 0,
                    dataLabels: {
                        enabled: true,
                        distance: -20,
                        filter: {
                            property: 'percentage',
                            operator: '>',
                            value: 4
                        },
                        style: {
                            fontWeight: 'bold',
                        },
                        formatter: function(){
                            var string;
                            string = '<span class="h5">' + this.key.slice(0,2) + '<br>占' + this.percentage.toFixed(0) + "%</span>";
                            return string;
                        }
                    }
                },
                series: {
                    allowPointSelect: true,
                    cursor: 'pointer',
                    point: {
                        events: {
                            click: function(){
								var filter_region = this.name, data, heatWeight
                                switch(this["selected"]){
                                    case(undefined):
									case(false):
										data = res.filter(function(el){
											return el.type == filter_region
										})
										heatWeight = 2
                                        break;
									case(true):
										data = res
										heatWeight = 3
                                        break;
								}
								fire_risk_heatmap(data, heatWeight)
                            }
                        }
                    }
                }
            },
            series: [{
                name: '比例：',
                data: chart_array_disatype
            }]
		})
		if (region) {
			$("#topic-fire-report-risk-type-chart-title").html("火災通報類型風險比例圖(" + region + ")")
		} else {
			$("#topic-fire-report-risk-type-chart-title").html("火災通報類型風險比例圖")
		}
	}

	// 歷史火災點位查詢
	$("#topic-fire-report-history-trig").click(function(){
		var input = {
				start: $("#topic-fire-report-history-input-year-start").val(),
				end: $("#topic-fire-report-history-input-year-end").val(),
				region: $("#topic-fire-report-history-input-region").val()
			},
			btnDOM = $(this),
			rangeDiffDays = (time_sql_processing_date(input.end) - time_sql_processing_date(input.start)) /3600000 / 24
		if (input.end >= input.start && rangeDiffDays <= 100) {
			topic_fire_report_remove()
			btnDOM.attr("disabled", true)
			$("#topic-fire-report-history-content").html('<div class="spinner-border text-danger" role="status"> <span class="sr-only">Loading...</span> </div>')
			ajax_call_async(publicPath + "/napi/obs/firecase?startTime=" + input.start + "T00%3A00%3A00&endTime=" + input.end + "T23%3A59%3A59", 
				function(res){
					if (res.status && res.info) {
						var filterFireReport = res.info.filter(function(el){
								if (el.caseTypeId != null) {
									return el.caseTypeId.slice(0,1) == "1"
								}
							}),
							html = { table: "" },
							geo = new geoJsonTemplate()
						filterFireReport.forEach(function(el){
							if (typeof(el.caseAddress) != "string") {
								el.caseAddress = "-"
							}
							var thisRegion = "-", regionStringIndex = el.caseAddress.search("區"), appendCondition = true
							if (regionStringIndex) {
								thisRegion = el.caseAddress.slice(regionStringIndex-2, regionStringIndex+1)
							}
							el.region = thisRegion
							if (input.region != "all") {
								appendCondition = Boolean(input.region == el.region)
							}
							if (appendCondition) {
								html.table += `
									<tr coor="${el.lat},${el.lon}">
										<td>${el.callerDatetime.replace("T", " ").slice(0,10)}</td>
										<td>${thisRegion}</td>
										<td>${reportType119[el.caseTypeId].caseTypeName}</td>
										<td>${el.caseAddress}</td>
									</tr>`
								geo.features.push({
									"type": "Feature",
									"geometry": {
										"type": "Point",
										"coordinates": [parseFloat(el.lon), parseFloat(el.lat)]
									},
									"properties": el
								})
							}
		
						})
						$("#topic-fire-report-history-content").html(`
							<h5 class="font-weight-bold mb-2 mt-2"><i class="fas fa-table mr-2"></i>歷史火災案件情資彙整</h5>
							<table class="table table-sm table-bordered table-pointer text-center">
								<thead class="thead-dark"><tr><th>日期</th><th>行政區</th><th>類型</th><th>地址</th></tr></thead>
								<tbody>${html.table}</tbody>
							</table>`
						)
						$("#topic-fire-report-history-content table").DataTable()
						$("#topic-fire-report-history-content table tbody").on("click", "tr", function(){
							var target = $(this).attr("coor").split(",")
							map.setView(target, 18)
						})
						overlay_dataset["topic-fire-report-history-layer"] = L.geoJSON(geo, {
							pointToLayer: function(feature, latlng) {
								return L.canvasMarker(latlng, {
									radius: 15,
									img: {
										url: 'marker_icon/fire_point.png',
										size: [32, 32],
										offset: { x: 0, y: 0 },
									}
								}).bindPopup('<div id="other_div" class="w-300">讀取中...</div>');
							}
						}).addTo(map).on("click", function(e){
							var thisMarker = e.layer.feature
							setTimeout(function(){
								$("#other_div").html(`
									<h5 class="font-weight-bold">行政區：${thisMarker.properties.region}</h5>
									<h6>起火類型：${null_Converter_v2(thisMarker.properties.fireDefine)}</h6>
									<h6>火警類型：${reportType119[thisMarker.properties.caseTypeId].caseTypeName}</h6>
									<h6>地址：${thisMarker.properties.caseAddress}</h6>
									<h6>通報時間：${thisMarker.properties.callerDatetime}</h6>
									<h6>出動時間：${event_fire_time_processing(thisMarker.properties.dispatchDatetime)}</h6>
									<h6>控制時間：${event_fire_time_processing(thisMarker.properties.controlDatetime)}</h6>
									<h6>撲滅時間：${event_fire_time_processing(thisMarker.properties.putOutDatetime)}</h6>
									<h6>離開時間：${event_fire_time_processing(thisMarker.properties.caseOutDatetime)}</h6>
									<h6>備註：${thisMarker.properties.note}</h6>
									<h6>街景連結：<button type="button" class="btn btn-link p-0 point-google-street" lon="${thisMarker.geometry.coordinates[0]}" lat="${thisMarker.geometry.coordinates[1]}">另開分頁檢視</button></h6>`
								)
							}, 1000)
						})
					} else {
						toast_open("資料倉儲119資料庫API介接異常")
					}
					btnDOM.attr("disabled", false)
				},
				function () {
					toast_open("資料倉儲119資料庫API介接異常")
					btnDOM.attr("disabled", false)
					$("#topic-fire-report-history-content").html("")
				}
			)
		} else if (input.end >= input.start && rangeDiffDays > 100) {
			alert("您選擇查詢的時間區段天數大於100天！")
		} 
		else {
			alert("您選擇查詢的時間區段，開始時間晚於結束時間或是結束時間早於開始時間！")
		}
	})

	var reportType119 = {"1":{"caseTypeId":"1","nfaType":"火災","nfaTypeId":"01","flag":"1","caseTypeName":"火警","nfaTopTypeName":"火災","nfaTopTypeId":"01","eocTypeId":null},"100":{"caseTypeId":"100","nfaType":"火災-未知","nfaTypeId":"15","flag":"1","caseTypeName":"火警-未知","nfaTopTypeName":"火災","nfaTopTypeId":"01","eocTypeId":null},"101":{"caseTypeId":"101","nfaType":"火災-透天厝","nfaTypeId":"02","flag":"1","caseTypeName":"火警-透天厝","nfaTopTypeName":"火災","nfaTopTypeId":"01","eocTypeId":null},"102":{"caseTypeId":"102","nfaType":"火災-集合住宅","nfaTypeId":"01","flag":"1","caseTypeName":"火警-集合住宅","nfaTopTypeName":"火災","nfaTopTypeId":"01","eocTypeId":null},"103":{"caseTypeId":"103","nfaType":"火災-倉庫","nfaTypeId":"11","flag":"1","caseTypeName":"火警-倉庫","nfaTopTypeName":"火災","nfaTopTypeId":"01","eocTypeId":null},"104":{"caseTypeId":"104","nfaType":"火災-旅館、百貨商場用途建築物","nfaTypeId":"04","flag":"1","caseTypeName":"火警-旅館、百貨商場用途建築物","nfaTopTypeName":"火災","nfaTopTypeId":"01","eocTypeId":null},"105":{"caseTypeId":"105","nfaType":"火災-運輸中樞用途建築物","nfaTypeId":"09","flag":"1","caseTypeName":"火警-運輸中樞用途建築物","nfaTopTypeName":"火災","nfaTopTypeId":"01","eocTypeId":null},"106":{"caseTypeId":"106","nfaType":"火災-電影院用途建築物","nfaTypeId":"07","flag":"1","caseTypeName":"火警-電影院用途建築物","nfaTopTypeName":"火災","nfaTopTypeId":"01","eocTypeId":null},"107":{"caseTypeId":"107","nfaType":"火災-學校、醫院、老人院建築物","nfaTypeId":"06","flag":"1","caseTypeName":"火警-學校、醫院、老人院建築物","nfaTopTypeName":"火災","nfaTopTypeId":"01","eocTypeId":null},"108":{"caseTypeId":"108","nfaType":"火災-毒災場所","nfaTypeId":"15","flag":"1","caseTypeName":"火警-毒災場所","nfaTopTypeName":"火災","nfaTopTypeId":"01","eocTypeId":null},"109":{"caseTypeId":"109","nfaType":"火災-大型違章建築區與傳統市場(含工廠)","nfaTypeId":"15","flag":"1","caseTypeName":"火警-大型違章建築區與傳統市場(含工廠)","nfaTopTypeName":"火災","nfaTopTypeId":"01","eocTypeId":null},"110":{"caseTypeId":"110","nfaType":"火災-石化廠建築物","nfaTypeId":"05","flag":"1","caseTypeName":"火警-石化廠建築物","nfaTopTypeName":"火災","nfaTopTypeId":"01","eocTypeId":null},"111":{"caseTypeId":"111","nfaType":"火災-古蹟、文化財","nfaTypeId":"15","flag":"1","caseTypeName":"火警-古蹟、文化財","nfaTopTypeName":"火災","nfaTopTypeId":"01","eocTypeId":null},"112":{"caseTypeId":"112","nfaType":"火災-地下建築物(如地下街)","nfaTypeId":"15","flag":"1","caseTypeName":"火警-地下建築物(如地下街)","nfaTopTypeName":"火災","nfaTopTypeId":"01","eocTypeId":null},"113":{"caseTypeId":"113","nfaType":"火災-高層建築物(10層樓以上)","nfaTypeId":"02","flag":"1","caseTypeName":"火警-高層建築物(10層樓以上)","nfaTopTypeName":"火災","nfaTopTypeId":"01","eocTypeId":null},"120":{"caseTypeId":"120","nfaType":"火災-汽車","nfaTypeId":"08","flag":"1","caseTypeName":"火警-汽車","nfaTopTypeName":"火災","nfaTopTypeId":"01","eocTypeId":null},"121":{"caseTypeId":"121","nfaType":"火災-機車","nfaTypeId":"08","flag":"1","caseTypeName":"火警-機車","nfaTopTypeName":"火災","nfaTopTypeId":"01","eocTypeId":null},"122":{"caseTypeId":"122","nfaType":"火災-隧道","nfaTypeId":"15","flag":"1","caseTypeName":"火警-隧道","nfaTopTypeName":"火災","nfaTopTypeId":"01","eocTypeId":null},"123":{"caseTypeId":"123","nfaType":"火災-軌道型交通工具","nfaTypeId":"09","flag":"1","caseTypeName":"火警-軌道型交通工具","nfaTopTypeName":"火災","nfaTopTypeId":"01","eocTypeId":null},"124":{"caseTypeId":"124","nfaType":"火災-化學、毒劑交通工具","nfaTypeId":"15","flag":"1","caseTypeName":"火警-化學、毒劑交通工具","nfaTopTypeName":"火災","nfaTopTypeId":"01","eocTypeId":null},"125":{"caseTypeId":"125","nfaType":"火災-船舶","nfaTypeId":"13","flag":"1","caseTypeName":"火警-船舶","nfaTopTypeName":"火災","nfaTopTypeId":"01","eocTypeId":null},"126":{"caseTypeId":"126","nfaType":"火災-航空器","nfaTypeId":"09","flag":"1","caseTypeName":"火警-航空器","nfaTopTypeName":"火災","nfaTopTypeId":"01","eocTypeId":null},"127":{"caseTypeId":"127","nfaType":"火災-山林田野(平地)","nfaTypeId":"12","flag":"1","caseTypeName":"火警-山林田野(平地)","nfaTopTypeName":"火災","nfaTopTypeId":"01","eocTypeId":null},"128":{"caseTypeId":"128","nfaType":"火災-山林田野(山地)","nfaTypeId":"12","flag":"1","caseTypeName":"火警-山林田野(山地)","nfaTopTypeName":"火災","nfaTopTypeId":"01","eocTypeId":null},"130":{"caseTypeId":"130","nfaType":"火災-垃圾","nfaTypeId":"15","flag":"1","caseTypeName":"火警-垃圾","nfaTopTypeName":"火災","nfaTopTypeId":"01","eocTypeId":null},"131":{"caseTypeId":"131","nfaType":"火災-電線桿(電纜)","nfaTypeId":"15","flag":"1","caseTypeName":"火警-電線桿(電纜)","nfaTopTypeName":"火災","nfaTopTypeId":"01","eocTypeId":null},"132":{"caseTypeId":"132","nfaType":"火災-瓦斯漏氣","nfaTypeId":"15","flag":"0","caseTypeName":"火警-瓦斯漏氣","nfaTopTypeName":"火災","nfaTopTypeId":"01","eocTypeId":null},"133":{"caseTypeId":"133","nfaType":"火災-災報器作響","nfaTypeId":"15","flag":"1","caseTypeName":"火警-警報器作響","nfaTopTypeName":"火災","nfaTopTypeId":"01","eocTypeId":null},"134":{"caseTypeId":"134","nfaType":"火災-查看案件","nfaTypeId":"15","flag":"1","caseTypeName":"火警-查看案件","nfaTopTypeName":"火災","nfaTopTypeId":"01","eocTypeId":null}}
}
